import fundaNowClient from '@/client/fundaNowClient'

export default {
  getNotices() {
    return fundaNowClient.call({
      url: '/notices/',
      method: 'GET'
    })
  },
  getNotice(uuid) {
    return fundaNowClient.call({
      url: `/notices/${uuid}`,
      method: 'GET'
    })
  },
  getModalNotice() {
    return fundaNowClient.call({
      url: '/notices/',
      method: 'GET',
      params: {
        top_notice: true
      }
    })
  },
}
